import { UseLoading } from "@/common/composition/loading";
import { UseCollection } from "@/common/composition/use-collection";
import { AuditItem, AuditInput } from "./models";
import * as api from "./api";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { debounce } from "@/fp";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import { SharedState } from "@/common/state";
import { ICONS } from "@/common/icons.map";
import { state as playbooks_state } from "../../data/state";
const {
  clear,
  has_more,
  has_no_results,
  is_loading,
  items,
  load_items,
} = UseCollection<AuditItem, AuditInput>(api.get_playbook_audit);

const on_filter_changed = debounce(250)(async () => {
  await load_items({
    cursor: "",
    filters: {
      data_sources: get_ids(selected_source.value!),
      information_type: get_ids(selected_info_type.value!),
      playbooks: get_ids(selected_playbook.value!),
    },
  });
});

const [
  data_sources,
  selected_source,
  set_selected_source,
  init_data_sources,
] = UseDropdownItems<{ id: string; name: string; icon: string }>(
  [],
  on_filter_changed
);

const [
  info_types,
  selected_info_type,
  set_selected_info_type,
  init_info_types,
] = UseDropdownItems<{ id: string; name: string; icon: string }>(
  [],
  on_filter_changed
);

const [
  playbooks,
  selected_playbook,
  set_selected_playbook,
  init_playbooks,
] = UseDropdownItems<{ id: string; name: string }>([], on_filter_changed);

const init_filters = () => {
  init_data_sources([
    {
      id: "all",
      name: "All",
      icon: "All",
    },
    ...data_sources_state.all_sources.value
      .filter((f) => f.runtime.enabled)
      .map((s) => {
        return {
          id: s.id,
          name: s.name,
          icon: s.runtime.icon,
        };
      }),
  ]);

  init_info_types([
    {
      id: "all",
      name: "All",
      icon: "All",
    },
    ...SharedState.l0InfoTypes.value.map((d) => {
      return {
        id: d.id,
        name: d.labelName,
        icon: ICONS.L0_ICONS.get(d.code),
      };
    }),
  ]);

  init_playbooks([
    {
      id: "all",
      name: "All",
    },
    ...playbooks_state.scripts.value.map((d) => {
      return {
        id: d.id,
        name: d.action,
      };
    }),
  ]);
  set_selected_source(data_sources.value[0].id);
  set_selected_info_type(info_types.value[0].id);
  set_selected_playbook(playbooks.value[0].id);
};

const init = async () => {
  await playbooks_state.init();
  init_filters();
  await load_items({
    cursor: "",
    filters: {
      data_sources: [],
      information_type: [],
      playbooks: [],
    },
  });
};

const get_ids = (selected_val: { id: string }): string[] => {
  return selected_val.id == "all" ? [] : [selected_val.id];
};

export const state = {
  init,
  is_loading,
  items,
  has_more,
  has_no_results,
  on_filter_changed,
  // == filters ==
  // sources
  data_sources,
  selected_source,
  set_selected_source,
  // info types
  info_types,
  selected_info_type,
  set_selected_info_type,
  // playbooks
  playbooks,
  selected_playbook,
  set_selected_playbook,
};
